import uniqid from 'uniqid';
import keyCodes from '@utils/key-codes';
import sharedParent from '@utils/shared-parent';
import FocusTrap from '@utils/focus-trap';

var VCA = VCA || {};

VCA.HeaderSiteSearch = (function ($) {

    const ui = {};

    function cacheUI() {
        ui.$body = $(document.body);
        ui.$close = $('.header-sitesearch__close-btn');
        ui.$desktopIcon = $('#SiteSearchDesktopIcon');
        ui.$desktopSearch = $('#HeaderSiteSearchDesktop');
        ui.$mobileSearch = $('.header-sitesearch__mobile');
        ui.$icon = $('.site-search-icon');
        ui.$iconActive = $('.site-search-icon-active');
        ui.$mobileIcon = $('#SiteSearchMobileIcon');
        ui.$searchBtn = $('.header-sitesearch__search-btn');
        ui.$desktopSearchInput = $('#DesktopSiteSearchText');
        ui.$mobileSearchInput = $('#MobileSiteSearchText');
        ui.$mobileSearchInputMegaNav = $('#MobileSiteSearchTextMegaNav');

        // abstract UI
        ui.focusTrap = null;
    }

    function bindEvents() {
        ui.$desktopIcon.on('click', toggleDesktopSearchBar);
        ui.$desktopIcon.on('keyup', onDesktopIconKeyup);
        ui.$mobileIcon.on('click', displayMobileSearchBar);
        ui.$close.on('click', hideMobileSearchBar);
        ui.$searchBtn.on('click', initSearch);
        ui.$desktopSearchInput.on('keyup', initSearchOnEnter);
        ui.$mobileSearchInput.on('keyup', initSearchOnEnter);
        ui.$mobileSearchInputMegaNav.on('keyup', initSearchOnEnter);
    }

    function onDesktopIconKeyup(event) {
        if(!ui.focusTrap) {
            const key = event.which ? event.which : event.keyCode;
            if(key === keyCodes.ARROW_DOWN) {
                displayDesktopSearchBar();
                if(ui.focusTrap.$current.is(ui.$desktopIcon)) {
                    ui.focusTrap.next();
                }
            } else if(key === keyCodes.ARROW_UP) {
                displayDesktopSearchBar();
                ui.focusTrap.last();
            }
        }
    }

    function toggleDesktopSearchBar() {
        const isActive = ui.$desktopSearch.hasClass('active');

        if (isActive) {
            hideDesktopSearchBar();
        } else {
            displayDesktopSearchBar();
        }
    }

    function displayDesktopSearchBar() {
        ui.$desktopSearch.addClass('active').fadeIn('fast');
        ui.$desktopIcon.attr('aria-expanded', true);
        ui.$iconActive.show();
        ui.$icon.hide();

        $(document).on('click.siteSearch', checkOutsideClick);

        const $parentEl = sharedParent(ui.$desktopIcon, ui.$desktopSearch);

        initFocusTrap($parentEl);
    }

    function hideDesktopSearchBar() {
        ui.$desktopSearch.removeClass('active').fadeOut('fast');
        ui.$desktopIcon.attr('aria-expanded', false);
        ui.$iconActive.hide();
        ui.$icon.show();

        $(document).off('click.siteSearch');

        ui.focusTrap?.$focusable.off('keyup.siteSearch');
        ui.focusTrap = ui.focusTrap?.destroy() || null;
    }

    function displayMobileSearchBar() {
        ui.$body.addClass('noscroll');
        ui.$mobileSearch.show();
        ui.$mobileIcon.attr('aria-expanded', true);

        initFocusTrap(ui.$mobileSearch);
    }

    function hideMobileSearchBar() {
        ui.$body.removeClass('noscroll');
        ui.$mobileSearch.hide();
        ui.$mobileIcon.attr('aria-expanded', false);

        ui.focusTrap = ui.focusTrap?.destroy() || null;
    }

    function initFocusTrap($rootEl, allowBreakout = true) {
        ui.focusTrap = new FocusTrap($rootEl, {
            allowBreakout,
            nextKeys: [ keyCodes.ARROW_DOWN ],
            prevKeys: [ keyCodes.ARROW_UP ],
            onBreakout() {
                hideDesktopSearchBar();
            }
        });

        ui.focusTrap.$focusable.on('keyup.siteSearch', checkInnerKeyup);
    }

    function initSearch(event) {
        event.preventDefault();
        let btn = $(event.currentTarget);

        let isMobile = $(event.currentTarget).closest('.header-sitesearch__container').hasClass('mobile');

        if (isMobile) {
            mobileSearch(btn);
        } else {
            desktopSearch(btn);
        }
    }

    function initSearchOnEnter(event) {
        if (event.keyCode === keyCodes.ENTER) {
            event.preventDefault();
            let btn = $(event.currentTarget);
            let isMobile = $(event.currentTarget).closest('.header-sitesearch__container').hasClass('mobile');

            if (isMobile) {
                mobileSearch(btn);
            } else {
                desktopSearch(btn);
            }
        }
    }
    function mobileSearch(btn) {

        let redirectUrl = btn.closest('.header-sitesearch__container').find('.header-sitesearch__search-btn').data('redirect');
        let searchText = btn.closest('.header-sitesearch__container').find('.header-sitesearch__search-input').val();

        if (searchText) {
            location.href = redirectUrl + "#q=" + searchText;
            hideMobileSearchBar()
        }
    }

    function desktopSearch(btn) {
        let redirectUrl = btn.closest('.header-sitesearch__container').find('.header-sitesearch__search-btn').data('redirect');
        const searchText = ui.$desktopSearchInput.val();

        if (searchText) {
            location.href = redirectUrl + "#q=" + searchText;
        }
    }

    function checkInnerKeyup(event) {
        const key = event.which ? event.which : event.keyCode;
        if(key === keyCodes.ESCAPE) {
            hideDesktopSearchBar();
            hideMobileSearchBar();
        }
    }

    function checkOutsideClick(event) {
        const target = $(event.target);

        if (target.closest(ui.$desktopIcon).length === 0 &&
            target.closest(ui.$desktopSearch).length === 0 &&
            !target.is(ui.$desktopIcon)) {

            hideDesktopSearchBar();
        }
    }

    function setupAccessibility() {
        const id = uniqid.time('siteSearch_');
        const desktopId = `${id}_desktop`;
        const mobileId = `${id}_mobile`;

        ui.$desktopSearch.attr('id', desktopId);
        ui.$mobileSearch.attr('id', mobileId);

        ui.$desktopIcon.attr({ 'aria-expanded': false, 'aria-controls': desktopId });
        ui.$mobileIcon.attr({ 'aria-expanded': false, 'aria-controls': mobileId });
    }

    function init() {
        cacheUI();
        setupAccessibility();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.HeaderSiteSearch.init();
});
